import { render, staticRenderFns } from "./OrderTradeForm.vue?vue&type=template&id=7cdee06b&scoped=true"
import script from "./OrderTradeForm.vue?vue&type=script&lang=js"
export * from "./OrderTradeForm.vue?vue&type=script&lang=js"
import style0 from "./OrderTradeForm.vue?vue&type=style&index=0&id=7cdee06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdee06b",
  null
  
)

export default component.exports